/**
 * IconButton/typed.ts
 * desc: typed view of the still-JS IconButton for icons written in TypeScript
 * note: delete when IconButton converts — the cast masks its real signature
 */
import type { ComponentType, MouseEvent, ReactNode, Ref } from 'react';
import IconButtonUntyped from './index';

// the props every icon accepts from its callers
export interface IconProps {
    'aria-expanded'?: boolean;
    // overrides the icon's own name — for toggles whose purpose is not the icon's name
    'aria-label'?: string;
    'aria-pressed'?: boolean;
    className?: string;
    disabled?: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    readOnly?: boolean;
    ref?: Ref<HTMLElement>;
    tooltip?: string | null;
    [dataAttribute: `data-${string}`]: string | undefined;
}

export interface IconButtonProps extends IconProps {
    baseClassName: string;
    children: ReactNode;
    label: string;
}

const IconButton = IconButtonUntyped as unknown as ComponentType<IconButtonProps>;

export default IconButton;
